import { useLingui } from "@lingui/react/macro"
import React from "react"

import { newsletterSubscription } from "../../../../utils/requests/hubspot"
import EmailForm from "../../../email-form"
import * as style from "./index.module.scss"

interface Props {
  setShowConfirmation: (value: boolean) => void
}

const NewsletterEmailForm = ({ setShowConfirmation }: Props) => {
  const { t } = useLingui()
  return (
    <EmailForm
      className={style.form}
      submitForm={newsletterSubscription}
      buttonText={t`Subscribe`}
      placeholderText={t`Enter your email`}
      formName="Newsletter subscription"
      onSubmitSuccess={() => setShowConfirmation(true)}
      buttonLocation="footer"
    />
  )
}

export default NewsletterEmailForm
